import { Suspense, lazy, type ComponentProps, type ReactNode } from 'react';

const ContactDealerInlineForm = lazy(
    () => import(/* webpackChunkName: "ContactDealerInlineForm" */ './ContactDealerInlineForm.tsx')
);

type Props = ComponentProps<typeof ContactDealerInlineForm> & {
    load?: boolean;
    fallback?: ReactNode;
};

export const ContactDealerInlineFormLoader = ({
    load,
    fallback = '',
    ...props
}: Props): ReactNode => {
    return (
        <>
            {load && (
                <Suspense fallback={fallback}>
                    <ContactDealerInlineForm {...props} />
                </Suspense>
            )}
        </>
    );
};
